import { Component, Input } from "@angular/core";

export interface BeadListItemData {
  letter?: string;
  beadName: string;
  beadColor: string;
  description?: string;
  count?: number;
  paletteDetailId: number;
  paletteTypeId: number;
  paletteId: number;
}

@Component({
  selector: "app-bead-list-item",
  templateUrl: "./bead-list-item.component.html",
  styleUrls: ["./bead-list-item.component.css"],
})
export class BeadListItemComponent {
  @Input() bead: BeadListItemData;
  @Input() showLetter = false;
  @Input() showCount = true;
  @Input() showDescription = true;
  @Input() beadSize: "small" | "medium" | "large" = "medium";
}
